import { useEffect } from 'react';
import ls from '@/utils/localStorage';
import useUpdate from './useUpdate';

const useHideTips = (tipsKey: string) => {
  const updateFn = useUpdate();

  const handleHideTips = () => {
    if (!ls.get(tipsKey)?.done) {
      ls.set(tipsKey, { done: true });
      updateFn();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleHideTips);
    return () => {
      document.removeEventListener('click', handleHideTips);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useHideTips;
